var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogleDesktopShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 12,
  viewBox: "0 0 16 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M.4 8.432s.35-1.157 1.281-2.409c.392-.526 1.38-1.481 1.694-1.71 2.2-.938 5.683-1.276 5.683-1.276V0L16 6.063 9.058 12V8.932s-4.777-.02-6.125.437C1.889 9.723 1 10.725.889 11.615.856 11.882 0 11.7 0 11.7z"
})));
export default SvgGoogleDesktopShare;